/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BarChart } from "../models/http/charts/bar-chart/bar-chart.model";
import { MapChart } from "../models/http/charts/map-chart/map-chart.model";
import { PieChart } from "../models/http/charts/pie-chart/pie-chart.model";
import { LineChart } from "../models/http/charts/line-chart/line-chart.model";
import { HardwareAssetsRealtimeInformation } from "../models/http/dashboard/hardware-assets-realtime-information.model";
import { HardwareAssetsRealtimeManufacturerTable } from "../models/http/dashboard/hardware-assets-realtime-manufacturer-table.model";
import { TotalMonths } from "../models/http/dashboard/hardware-assets-realtime-total-months.model";
import { ChartResponse } from "../models/ui/charts.model";
import { DashboardHardwareAssetsRealtimeHttpService } from "./http/dashboard-hardware-assets-realtime-http.service";

@Injectable({
	providedIn: "root"
})
export class DashboardHardwareAssetsRealtimeService {
	constructor(
		private _dashboardHardwareAssetsRealtimeHttpService: DashboardHardwareAssetsRealtimeHttpService
	) {}

	public getInformations(
		startDate: string,
		endDate?: string
	): Observable<HardwareAssetsRealtimeInformation> {
		return this._dashboardHardwareAssetsRealtimeHttpService.getInformations(startDate, endDate);
	}

	public getTotalEmissions(startDate: string, endDate?: string): Observable<TotalMonths> {
		return this._dashboardHardwareAssetsRealtimeHttpService.getTotalEmissions(
			startDate,
			endDate
		);
	}

	public getEmissionsByModelTotal(
		startDate: string,
		endDate?: string
	): Observable<ChartResponse<BarChart>> {
		return this._dashboardHardwareAssetsRealtimeHttpService.getEmissionsByModelTotal(
			startDate,
			endDate
		);
	}

	public getEmissionsByModelPerDevice(
		startDate: string,
		endDate?: string
	): Observable<ChartResponse<BarChart>> {
		return this._dashboardHardwareAssetsRealtimeHttpService.getEmissionsByModelPerDevice(
			startDate,
			endDate
		);
	}

	public getEmissionsByLocation(category?: string): Observable<ChartResponse<BarChart>> {
		return this._dashboardHardwareAssetsRealtimeHttpService.getEmissionsByLocation(category);
	}

	public getManufacturersEmission(
		category?: string
	): Observable<HardwareAssetsRealtimeManufacturerTable> {
		return this._dashboardHardwareAssetsRealtimeHttpService.getManufacturersEmission(category);
	}

	public getManufacturerPieChart(category?: string): Observable<ChartResponse<PieChart>> {
		return this._dashboardHardwareAssetsRealtimeHttpService.getManufacturerPieChart(category);
	}

	public getCarbonIntensityMap(): Observable<ChartResponse<MapChart>> {
		return this._dashboardHardwareAssetsRealtimeHttpService.getCarbonIntensityMap();
	}

	public getEnergyConsumption(): Observable<ChartResponse<LineChart>> {
		return this._dashboardHardwareAssetsRealtimeHttpService.getEnergyConsumption();
	}

	public getEmbodiedEmissions(): Observable<ChartResponse<LineChart>> {
		return this._dashboardHardwareAssetsRealtimeHttpService.getEmbodiedEmissions();
	}
}
